// extracted by mini-css-extract-plugin
module.exports = {"contentBody":"LoggedPage_contentBody__mG4ED"};